import axiosInstance from "../../interceptor/intercetptor-inctence";

export const getPreOrderListAPI = (data) => {
    return axiosInstance.post(`pharma/preorderList`, data);
}

export const deletePreOrderListAPI = (data) => {
    return axiosInstance.post(`pharma/deletePreorder`, data);
}


export const getPreOrderItemsAPI = (data) => {
    return axiosInstance.post(`pharma/getPreOrderItems`, data);
}

export const createPreOrderAPI = (data) => {
    return axiosInstance.post(`pharma/createpreorder`, data);
}

// Get pre-order details by ID
export const getPreOrderDetailsAPI = async (payload) => {
    try {
        const response = await axiosInstance.post("pharma/getpreorder", payload);
        return response;
    } catch (error) {
        console.error("Error fetching pre-order details:", error);
        throw error;
    }
};

// Update pre-order
export const updatePreOrderAPI = async (payload) => {
    try {
        const response = await axiosInstance.post("pharma/updatepreorder", payload);
        return response;
    } catch (error) {
        console.error("Error updating pre-order:", error);
        throw error;
    }
};

